var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.626953,
    width: 51,
    height: 51,
    rx: 14,
    fill: "#427DFE",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4330_65770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 10,
    width: 26,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7943 10.832H13.4609V40.1654H38.7943V10.832ZM22.1276 14.832V17.4987H30.1276V14.832H22.1276ZM26.1276 22.832C26.864 22.832 27.4609 23.429 27.4609 24.1654V32.1654C27.4609 32.9018 26.864 33.4987 26.1276 33.4987C25.3912 33.4987 24.7943 32.9018 24.7943 32.1654V24.1654C24.7943 23.429 25.3912 22.832 26.1276 22.832ZM32.1276 26.832C32.1276 26.0956 31.5307 25.4987 30.7943 25.4987C30.0579 25.4987 29.4609 26.0956 29.4609 26.832V32.1654C29.4609 32.9018 30.0579 33.4987 30.7943 33.4987C31.5307 33.4987 32.1276 32.9018 32.1276 32.1654V26.832ZM22.7943 29.4987C22.7943 28.7623 22.1973 28.1654 21.4609 28.1654C20.7246 28.1654 20.1276 28.7623 20.1276 29.4987V32.1654C20.1276 32.9018 20.7246 33.4987 21.4609 33.4987C22.1973 33.4987 22.7943 32.9018 22.7943 32.1654V29.4987Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4330_65770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4609 14.5H17.7943C17.0579 14.5 16.4609 15.097 16.4609 15.8333V36.5C16.4609 37.2364 17.0579 37.8333 17.7943 37.8333H34.4609C35.1973 37.8333 35.7943 37.2364 35.7943 36.5V15.8333C35.7943 15.097 35.1973 14.5 34.4609 14.5Z",
    fill: "#427DFE",
    stroke: "#427DFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4616 13.5H20.7949V18.8333H31.4616V13.5Z",
    stroke: "#427DFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/AssessmentIcon.94db98764fa6d9c383ec81617099895b.svg";
export { ForwardRef as ReactComponent };